module.exports = __webpack_public_path__ + "img/IMG_5886.f5c335fd.jpg";